import React, { useCallback, useEffect, useState } from 'react';
import { bildirimiKaydet, durumMetni, DURUM } from '../../utils/bildirimKayit';
import './AyarSatiri.css';

/*
  TELEFON BILDIRIMI AYARI
  -----------------------
  NEDEN VAR: bildirimler sessizce calismiyordu. Telefonun bildirim
  kaydi hic olusmamisti; sunucu gonderecek adres bulamayinca gonderim
  adimina bile gelmiyordu ve hicbir hata gorunmuyordu. Kayit sirasindaki
  butun hatalar da yutuluyordu (catch (e) {}), yani kullanicinin
  "bildirim gelmiyor" disinda bir bilgisi olmuyordu.

  Bu kart durumu ACIKCA yaziyor ve kapalıysa acma dugmesi veriyor.
  Sorun telefonda mi (izin verilmemis) sunucuda mi (kayit ulasmiyor)
  ayirt edilebiliyor.
*/

const BildirimAyari = ({ kaydet }) => {
  const [durum, setDurum] = useState(null);
  const [ayrinti, setAyrinti] = useState('');
  const [calisiyor, setCalisiyor] = useState(false);

  // Ilk acilista kullaniciya sistem penceresi GOSTERILMEZ; yalnizca
  // mevcut duruma bakilir. Pencere ancak dugmeye basilinca cikar.
  const bak = useCallback(async () => {
    const s = await bildirimiKaydet(kaydet, false);
    setDurum(s.durum);
    setAyrinti(s.ayrinti || '');
  }, [kaydet]);

  useEffect(() => { bak(); }, [bak]);

  const ac = async () => {
    setCalisiyor(true);
    try {
      const s = await bildirimiKaydet(kaydet, true);
      setDurum(s.durum);
      setAyrinti(s.ayrinti || '');
    } finally {
      setCalisiyor(false);
    }
  };

  // Tarayicida bu karta gerek yok. Bunun disinda kart HER ZAMAN
  // gosteriliyor: durum henuz bilinmiyorken de gorunuyor, cunku
  // gizlendiginde kullanicinin bildirimleri acacak bir yolu kalmiyordu.
  if (durum === DURUM.TARAYICI) return null;

  const hazir = durum === DURUM.HAZIR;

  return (
    <div className={hazir ? 'ba-kutu ba-hazir' : 'ba-kutu'}>
      <div className="ba-ust">
        <div className="ba-simge" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
               strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.7 21a2 2 0 0 1-3.4 0" />
          </svg>
        </div>
        <div className="ba-metin">
          <strong>Telefon bildirimleri</strong>
          <span>{durumMetni(durum, ayrinti)}</span>
        </div>
      </div>

      {!hazir && (
        <button type="button" className="ba-dugme" onClick={ac} disabled={calisiyor}>
          {calisiyor ? 'Açılıyor…' : 'Aç'}
        </button>
      )}
    </div>
  );
};

export default BildirimAyari;
